const ITEMS_PER_PAGE_FIRST_PAGE = 17;
const ITEMS_PER_PAGE = 18;

//display 17 firms on page 1 to allow room for the matchmaker highlight tile
export const getResultsCountForPage = (page: number): number =>
    page === 1 ? ITEMS_PER_PAGE_FIRST_PAGE : ITEMS_PER_PAGE;

export const getNumberOfPages = (totalResults: number): number =>
    // Add `1` to total results for matchmaker tile
    Math.ceil((totalResults + 1) / ITEMS_PER_PAGE);

export const getOffsetForPage = (page: number): number => (page === 1 ? 0 : -1);
